const styles = new Proxy({"Badge":"Badge-5650a"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const Badge = ({ link, name }: { link: string; name: string }) => (
  <a href={link} className={styles.Badge}>
    {name}
  </a>
);

export default Badge;
